import { zodResolver } from '@hookform/resolvers/zod'
import InnerBox from '@repo/ui/inner-box'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import { TranslationLocale } from '../../../../lib/types/enums/translation/translation.enum'
import { FormulaInput } from '../../../../lib/types/models/formula/formula-input'
import { BaseFormProps } from '../../../../lib/types/utils'
import { getSubmitAction } from '../../../../lib/utils/buttons-config/validation-buttons-config'
import { createStringSchema } from '../../../../lib/utils/validations/string-validation'
import { createTranslationsSchema } from '../../../../lib/utils/validations/translations-validation'
import { FORM_MODE } from '../../../../utils/constants/form.constants'
import ControlledSwitch from '../../../elements/controlled-switch'
import { Form, FormControl, FormField, FormItem } from '../../../elements/forms/form'
import ControlledInput from '../../../elements/inputs/controlled-input'
import TranslationsInput from '../../../elements/inputs/translations-input'
import ValidationButtons from '../../../elements/validation-buttons'

const formSchema: ZodType<FormulaInput> = z.object({
  code: createStringSchema('Code de la formule'),
  translations: createTranslationsSchema([TranslationLocale.FR]),
  description: createStringSchema('texte à afficher'),
  category: createStringSchema('catégorie'),
  displayLongVersionForClientSpace: z.boolean({
    message: 'Veuillez indiquer si la version longue doit être affichée'
  })
})

const JourneyPlaceFormulaForm = ({
  defaultValues,
  ...validationButtonProps
}: BaseFormProps<FormulaInput>) => {
  const form = useForm<FormulaInput>({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <InnerBox title="Formule">
        <form
          onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}
          className="flex flex-col gap-2"
        >
          <FormField
            control={form.control}
            name="code"
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledInput {...field} type="text" label="Code" required />
                </FormControl>
              </FormItem>
            )}
          />
          <TranslationsInput
            control={form.control}
            name="translations"
            label="Nom de la formule"
            requiredLocales={[TranslationLocale.FR]}
          />
          <FormField
            control={form.control}
            name="description"
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledInput
                    required
                    {...field}
                    type="text"
                    label="Texte à afficher fiche de dispo des ME"
                  />
                </FormControl>
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="category"
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledInput required {...field} type="text" label="Catégorie" />
                </FormControl>
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="displayLongVersionForClientSpace"
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledSwitch
                    {...field}
                    switchVariant="primary"
                    label="Afficher la version longue du questionnaire “Profil de l’enfant” sur l’espace client (Questionnaire Complémentaire)"
                    withBorder
                    borderClassName="border-grey-light p-1"
                    variant={'label-semibold'}
                  />
                </FormControl>
              </FormItem>
            )}
          />
        </form>
      </InnerBox>
      <ValidationButtons {...validationButtonProps} />
    </Form>
  )
}

export default JourneyPlaceFormulaForm
